import { createConfirmation } from "react-confirm";
import SeparatePrintDialog from "./SeparatePrintDialog";

export const showSeparatePrintDialog = createConfirmation(SeparatePrintDialog);
